import * as React from 'react';
import { Props } from '../types/types';

import parse from 'html-react-parser';

import { View, Text, Touchable, rem, Icon, IconButton, CenterButton } from '../libs/WebComponents';
import { QuestionType } from '../store/questions';
import { Button } from 'react-bootstrap';


export interface SwipeItemType{
   reference: string
   image: string
   title: string
   A: boolean
   B: boolean
}



let left =0;
const QuestionSwipe = (props: Props) => {
   const [isValid, setIsValid] = React.useState(props.page.required ? false : true);
   const [allAnswers, setAllAnswers] = React.useState<SwipeItemType[]>(props.page.answerslist && props.page.answerslist.length ? props.page.answerslist.map((answer: SwipeItemType)=>({...answer, A: false, B: false})) : []);
   const [direction, setDirection] = React.useState<'none' | 'left' | 'right' | 'pressed' | 'reset'>('none');
   const [moveX, setMoveX] = React.useState<number>(0);
   const [index, setIndex] = React.useState<number>(0);
   const [isAnswered, setIsAnswered] = React.useState<string>('');
   
   React.useEffect(()=>{
      props.setCanNext(isValid);
      props.setShowExplanationPage(()=>()=>props.showTip(props.page.question_type));
      return ()=>{
         props.setCanNext(true);
         props.setShowExplanationPage(null);
      }
   },[isValid]);

   const _swipeLeft = () => {
      setDirection('left');
      setIsAnswered('show');
      setTimeout(()=>setIsAnswered('EmoticonMad'),10);
      setAllAnswers((aa: SwipeItemType[])=>{
         aa[index] = {...aa[index], A: true, B: false};
         return aa;
      });
      nextCard();
   };

   const _swipeRight = () => {
      setDirection('right');
      setIsAnswered('show');
      setTimeout(()=>setIsAnswered('EmoticonHappy'),10);
      setAllAnswers((aa: SwipeItemType[])=>{
         aa[index] = {...aa[index], A: false, B: true};
         return aa;
      });
      nextCard();
   };
   
   const nextCard = React.useCallback(() => {
      setTimeout(()=>{
         setDirection(()=>{
            return 'reset';}
         );
      }, 300);
      setMoveX(0);
      setTimeout(()=>{
         setIsAnswered('');
      },1000);
      setTimeout(()=>{
         setIndex(i=>i+1);
         if (index <= allAnswers.length) setDirection('none');
      }, 500);
      if (index === allAnswers.length-1){
         setIsValid(true);
         setTimeout(()=>{
            const answers_swipe = allAnswers.map((a: SwipeItemType)=>({reference: a.reference, A: a.A, B: a.B}));
            props.setAnswers({answers_swipe: answers_swipe });
         }, 300);
      }
   },[index, allAnswers]);

   const _startMove = React.useCallback((e: any)=>{
      left = e.touches ? e.touches[0].clientX : e.clientX;
      setDirection('pressed');
   },[]);

   const _onMove = React.useCallback((e: any)=>{

      if (direction !== 'pressed') return;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      setMoveX(clientX - left);
   },[direction]);

   const _restartSwiper = React.useCallback(()=>{
      setAllAnswers(props.page.answerslist && props.page.answerslist.length ? props.page.answerslist.map((answer: SwipeItemType)=>({...answer, A: false, B: false})) : []);
      setIsValid(props.page.required ? false : true);
      setIndex(0);
   },[]);

   const _stopMove = React.useCallback((e: any)=>{

      if (direction === 'pressed' && moveX>100) {
         _swipeRight();
      }else if(direction === 'pressed' && moveX<-100){
         _swipeLeft();
      }else if (direction === 'pressed') {
         setDirection('none');
         setTimeout(()=>setMoveX(0),10);
      }
   },[moveX, direction]);

   React.useEffect(()=>{
      if (props.given_answers && Array.isArray(props.given_answers.answers_swipe))
      {
         setIndex(allAnswers.length);
         setIsValid(true);
      }
   },[props.given_answers]);

   return (
      <View className={'swiper-container'}>
         <View className={'view emoticon-left'}><IconButton onPress={_swipeLeft} name={'EmoticonMad'} iconSize={rem(6)} size={rem(7)} iconColor={'var(--color-gray)'} color={'transparent'} containerStyle={{maxHeight:rem(7),opacity:.7}} /></View>
         <View className={`cards-container ${direction}`}>
            {index <= allAnswers.length-1?<CardView
               answer={props.page.answerslist[index]}
               className={'front'}
               onPressIn={_startMove}
               onMove={_onMove}
               onPressOut={direction==='pressed'?_stopMove:null}
               swipeLeft={_swipeLeft}
               swipeRight={_swipeRight}
               style={moveX !==0 && direction ==='pressed'?{transform:'scale(1) translateX('+ moveX + 'px)',transition:'none'}:null}
            />:null}
            {index <= allAnswers.length-2?<CardView className={direction==='reset'?'to-front':'back'} answer={props.page.answerslist[index+1]} />:<View style={{top:-rem(1),flex:1, alignItems:'center',justifyContent:'center',position:'absolute',width:'100%',minHeight:'45vh'}}><Text h4 style={{display:'flex',textAlign:'center',opacity:.2}}>Klaar!</Text>
            <IconButton name="Revert" iconSize={rem(4)} size={rem(4.5)} containerStyle={{maxHeight:rem(6),opacity:0.5}} onPress={_restartSwiper} iconColor={'var(--bs-body-color)'} color={'var(--color-white)'} />
            </View>}
            <View className={`swiped-icon-indicator ${isAnswered!==''?isAnswered==='show'?'show':'animating':''}`}>{['EmoticonMad','EmoticonHappy'].includes(isAnswered)?<Icon name={isAnswered} size={rem(20)} color={isAnswered==='EmoticonMad'?'var(--color-red)':isAnswered==='EmoticonHappy'?'var(--color-green)':''} />:null}</View>
            </View>
         <View className={'view emoticon-right'}><IconButton onPress={_swipeRight} name={'EmoticonHappy'} iconSize={rem(6)} size={rem(7)} iconColor={'var(--color-gray)'} color={'transparent'} containerStyle={{maxHeight:rem(7),opacity:.7}} /></View>
      </View>
   );
}

const CardView = (props: Props) => {
   return <View className={`swiper-card ${props.className}`} style={props.style}>
      <View className={'shadow'} />
      <View className={'background'} />
      {props.answer?.image1 ? parse(props.answer.image1):null}
      <Text h5>{props.answer?.title}</Text>
      {props.onMove?<Touchable className={'clicker'} 
         onMove={props.onMove} onPressIn={props.onPressIn} onPressOut={props.onPressOut} onMouseLeave={props.onPressOut} onPressCancel={props.onPressOut}
      />:null}
      <IconButton name={'ChevronLeft'} onPress={props.swipeLeft} color={'var(--color-white)'} iconSize={rem(3)} size={rem(4)} containerStyle={{position:'absolute', top:'calc(50% - 2rem)',left:rem(-1.5)}}/>
      <IconButton name={'ChevronRight'} onPress={props.swipeRight} color={'var(--color-white)'} iconSize={rem(3)} size={rem(4)} containerStyle={{position:'absolute', top:'calc(50% - 2rem)',right:rem(-1.5)}}/>
   </View>
};


export default React.memo(QuestionSwipe);